var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "awaitingTickets" } },
    [
      _c("a-table", {
        staticClass: "custom-table2",
        attrs: {
          columns: _vm.columns,
          dataSource: _vm.waitingChatGetter,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        scopedSlots: _vm._u([
          {
            key: "email",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getVisitorValue(item, "email")) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "phone",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getVisitorValue(item, "phone")) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "name",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      !!item.conversation
                        ? item.conversation.fullname || "-"
                        : !!item.osrPayload
                        ? item.osrPayload.fullname
                        : "-"
                    ) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "createdDate",
            fn: function (createdDate) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("date")(createdDate)) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "assignedUser",
            fn: function (assignedUser, item) {
              return _c(
                "div",
                {},
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "ticket-select",
                      attrs: {
                        "default-value": assignedUser ? assignedUser._id : null,
                      },
                      on: {
                        change: function (value) {
                          return _vm.handleChange(value, item._id)
                        },
                      },
                    },
                    _vm._l(_vm.users.data, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            },
          },
          {
            key: "_id",
            fn: function (_id, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "d-flex w-100 justify-content-start" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton d-flex align-items-center",
                        on: {
                          click: function ($event) {
                            return _vm.view(item)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "16px",
                              display: "block",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.sendResponse")))]
                        ),
                        _vm._v(" "),
                        _c("ActionEdit"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton d-flex align-items-center",
                        on: {
                          click: function ($event) {
                            return _vm.archived(item)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "16px",
                              display: "block",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.archived")))]
                        ),
                        _vm._v(" "),
                        _c("md-icon", { staticStyle: { color: "#3fc5bd" } }, [
                          _vm._v("inventory_2"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end mt-3",
          staticStyle: { "margin-bottom": "100px" },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.waitingTickets.totalPages * _vm.perPage,
              pageSizeLocalStorageKey: "ticket-page-size",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "awaiting-message-details",
            title: _vm.$t("message.historyDetails"),
            centered: "",
            "hide-footer": "",
          },
          on: { hidden: _vm.reset },
        },
        [
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("message.chat"), active: "" } },
                [
                  _vm.selectedHistory.type === "osr"
                    ? _c(
                        "div",
                        [
                          _c("p", { staticClass: "p-2" }, [
                            _vm._v(_vm._s(_vm.selectedHistory.messages)),
                          ]),
                          _vm._v(" "),
                          _c("a-textarea", {
                            attrs: {
                              rows: 2,
                              placeholder: "Geri bildirim gonder",
                            },
                            model: {
                              value: _vm.responseText,
                              callback: function ($$v) {
                                _vm.responseText = $$v
                              },
                              expression: "responseText",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right",
                                      on: {
                                        click: function () {
                                          return this$1.$bvModal.hide(
                                            "awaiting-message-details"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.$t("message.cancel")) +
                                            "\n                                "
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right mr-2",
                                      attrs: {
                                        disabled: _vm.responseSending,
                                        variant: "primary",
                                      },
                                      on: { click: _vm.sendResponse },
                                    },
                                    [
                                      !_vm.responseSending
                                        ? [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(_vm.$t("message.send")) +
                                                "\n                                "
                                            ),
                                          ]
                                        : [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "spinner",
                                                spin: "",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("message.sending")
                                                ) +
                                                "...\n                                "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm.filteredMessages.length
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                },
                              },
                              [
                                _vm.filteredMessages.length
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "chat-scroll",
                                            rawName: "v-chat-scroll",
                                          },
                                        ],
                                        staticClass: "waiting-ticket-messages",
                                      },
                                      [
                                        _c("MessageList", {
                                          attrs: {
                                            "always-scroll-to-bottom": false,
                                            colors: _vm.colors,
                                            messages: _vm.getMessages(),
                                            participants: _vm.getParticipants(),
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("a-textarea", {
                                  attrs: {
                                    rows: 2,
                                    placeholder: "Geri bildirim gonder",
                                  },
                                  model: {
                                    value: _vm.responseText,
                                    callback: function ($$v) {
                                      _vm.responseText = $$v
                                    },
                                    expression: "responseText",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-4" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "12" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "float-right",
                                            on: {
                                              click: function () {
                                                return this$1.$bvModal.hide(
                                                  "awaiting-message-details"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ],
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "float-right mr-2",
                                            attrs: {
                                              disabled: _vm.responseSending,
                                              variant: "primary",
                                            },
                                            on: { click: _vm.sendResponse },
                                          },
                                          [
                                            !_vm.responseSending
                                              ? [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t("message.send")
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              : [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "spinner",
                                                      spin: "",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.sending"
                                                        )
                                                      ) +
                                                      "...\n                                    "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "b-alert",
                                  { attrs: { show: "", variant: "info" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.chatNotFound"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                      ]),
                ]
              ),
              _vm._v(" "),
              !!Object.keys(_vm.selectedHistory.visitor).length
                ? _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("message.visitorInfo") } },
                    [
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.fullName")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.visitorInfo.fullname) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.email")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.visitorInfo.email) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.phone")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.visitorInfo.phone) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v("IP"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.selectedHistory.visitor.ipAddress || "-"
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.browser")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.selectedHistory.visitor.browser || "-"
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userInfo" }, [
                        _c("div", { staticClass: "userInfo first" }, [
                          _vm._v(_vm._s(_vm.$t("message.os"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo sec" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.selectedHistory.visitor.os || "-") +
                              "\n                    "
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }